import { getAnnouncements } from "../../apis";
import { getBulkBlockDealData, getFIIDIIMFData, getHotPursuitData, getMergerDemergerData } from "../../apis/cds";
import { BUSINESS_LAYER_RESPONSE, NEWS_CMOT_MODE, TL_INDEX } from "../../utils/global_variables";
import { getApiExchangeNameFromMktSegId, getMktSegIdFromMappedMktSegId } from "../../utils/global_functions";
import dayjs from "dayjs";
import { _getScripsInfo } from "../watchlist";

// const handleTime = (jsonHotNews) => {
//     const [hours, minuts] = jsonHotNews.Time.split(":");
//     let isPM = parseInt(hours, 10) >= 12;
//     let formatedHours = parseInt(hours, 10) % 12;
//     formatedHours = formatedHours === 0 ? 12 : formatedHours;
//     let formatedTimeString = `${formatedHours}:${minuts} ${isPM ? "PM" : "AM"}`;
//     const [day, month, year] = jsonHotNews.Date.split("-");
//     return day + " " + month + "'" + year.slice(-2) + " " + formatedTimeString;
// };

function _handleTimeDifference(sDate, time) {
    let targetDate;
    if (time) {
        targetDate = dayjs(`${sDate} ${time}`, { format: 'DD/MM/YYYY HH:mm' });
    } else {
        targetDate = dayjs(`${sDate} 23:59:59`, { format: 'DD/MM/YYYY HH:mm:ss' });
    }
    let currentDate = dayjs();
    const secondsDifference = Math.abs(targetDate.diff(currentDate, 'second'));

    if (secondsDifference >= 31556926) {
        let yearAgo = Math.floor(secondsDifference / 31556926);
        return yearAgo > 1 ? yearAgo + " years ago" : yearAgo + " year ago";
    } else if (secondsDifference >= 2629746) {
        let monthAgo = Math.floor(secondsDifference / 2629746);
        return monthAgo > 1 ? monthAgo + " months ago" : monthAgo + " month ago";
    } else if (secondsDifference >= 86400) {
        let dayAgo = Math.floor(secondsDifference / 86400);
        return dayAgo > 1 ? dayAgo + " days ago" : dayAgo + " day ago";
    } else if (secondsDifference >= 3600) {
        let hourAgo = Math.floor(secondsDifference / 3600);
        return hourAgo > 1 ? hourAgo + " hours ago" : hourAgo + " hour ago";
    } else if (secondsDifference >= 60) {
        let minuteAgo = Math.floor(secondsDifference / 60);
        return minuteAgo > 1 ? minuteAgo + " minutes ago" : minuteAgo + " minute ago";
    } else if (secondsDifference < 60) {
        return secondsDifference > 1 ? secondsDifference + " seconds ago" : secondsDifference + " second ago";
    } else if (secondsDifference < 0) {
        return "0 second ago";
    }
}


async function _announcementsExchange(sExchange, nPage, nItems, jtenantToken, arrHoldingsScrips) {
    // Hari: adding additional data point to identify the scrip is having holdings or not
    // sExchange- to get announcements for particular exchange 
    // nPage- number of pages
    // nItems- number of items in each page
    // arrHoldingsScrips- to finding that any news is having holdings or not
    // jtenantToken- to get announcement news for particular tenant

    try {
        let objResp = await getAnnouncements(sExchange, nPage, nItems, jtenantToken);
        if (objResp?.data?.ResponseObject?.type === "success") {
            if (objResp.data.ResponseObject.resultset.length) {
                for (let eachNews of objResp.data.ResponseObject.resultset) { // checking the news are having holding are not
                    const holdings = arrHoldingsScrips?.find((hotData) => hotData?.nMarketSegmentId?.toString() === (eachNews?.ScripData_NSE !== '-') ? eachNews?.ScripData_NSE?.MarketSegmentId?.toString() && hotData?.nToken?.toString() : eachNews?.ScripData_BSE?.ODINCode?.toString());
                    if (holdings) {
                        eachNews.isHoldings = true;
                    } else {
                        eachNews.isHoldings = false;
                    }
                }
                const uniqueCompanyCodes = [...new Set(objResp.data.ResponseObject.resultset.map(obj => obj.CompanyCode))];
                const arrUniqueObjects = uniqueCompanyCodes.map(companyCode => { //finding unique objects 
                    return objResp.data.ResponseObject.resultset.find(obj => obj.CompanyCode === companyCode);
                });
                return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: arrUniqueObjects };
            } else {
                return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: objResp.data.ResponseObject.errorcode };
            }
        } else {
            return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: null };
        }
    }
    catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}

function _sectorWiseNewsSuccess(arrPayload) {
    // Hari: modifying the sectorWiseNews data structure according to need
    // arrPayload is API response of sector wise news
    try {
        const arrJsonNews = arrPayload;
        const arrUpdatedSectorWiseNews = [];
        for (let jsonNews of arrJsonNews) {
            const updatedSectorWiseNews = {
                id: jsonNews.SNo,
                news_content: jsonNews.Heading,
                category_name: jsonNews.SectorName,
                date_time: _handleTimeDifference(jsonNews.Date, null),
                news_channel_name: null,
                exchange_type: null,
                sub_category: null,
                category: [],
                SNo: jsonNews.SNo
            };
            arrUpdatedSectorWiseNews.push(updatedSectorWiseNews);
        }

        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: arrUpdatedSectorWiseNews };

    } catch (error) {

        return { status: true, message: error, data: null };
    }
};


function _exchangeAnnouncementsSuccess(arrAnnouncements) {
    //Hari: modifying the announcement data structure according to need
    //arrAnnouncements is a API response of announcements
    try {
        let arrUpdatedAnnouncements = [];
        for (let jsonAnnounce of arrAnnouncements) {
            const updatedAnnouce = {
                id: jsonAnnounce.CompanyCode,
                news_channel_name: jsonAnnounce.CompanyLongName,
                news_content: jsonAnnounce.Caption,
                date_time: _handleTimeDifference(jsonAnnounce.Date?.split(" ")[0], jsonAnnounce.Date?.split(" ")[1]),
                category_name: null,
                sub_category: null,
                exchange_type: null,
                memo: jsonAnnounce.Memo,
                category: [{
                    id: 1,
                    sub_category: null,
                    price: null,
                    profit_loss: null
                }]
            };
            arrUpdatedAnnouncements.push(updatedAnnouce);
        }

        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: arrUpdatedAnnouncements };
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: error };
    }
}



async function _FIIDIIMFData(sType, jtenantToken) {
    //Hari: modifying the  data structure according to the news sType
    // sType - type of news
    //jtenantToken -to get FII,DII,and MF news from a particular tenant
    try {
        const objResp = await getFIIDIIMFData({ type: sType, jtenantToken: jtenantToken });

        let data;

        if (sType === "FII") {
            if (objResp.data.ResponseObject.type === "success") {
                data = objResp.data.ResponseObject.resultset.map((each) => (
                    {
                        id: 1, equity: {
                            equity_heading: 'Equity',
                            equity_gross_purchase: each.EquityGrossPurchase,
                            equity_gross_sales: each.EquityGrossSales,
                            equity_net_investment: each.EquityNetInvestment,
                            equity_cumulativie_net_investment: each.EquityCumulativeNetInvestment
                        }, debit: {
                            debt_heading: 'Debt',
                            debt_gross_purchase: each.DebtGrossPurchase,
                            debt_gross_sales: each.DebtGrossSales,
                            debt_net_investment: each.DebtNetInvestment,
                            debt_cumulativie_net_investment: each.DebtCumulativeNetInvestment
                        }, heading: {
                            date: each.FIIDate,
                            gross_purchase: 'Gross Purchase',
                            gross_sales: 'Gross Sales',
                            net_investment: 'Net Investment',
                            cumulativie_net_investment: 'Cumulative Net Investment'
                        }
                    }
                ));
            }
        } else if (sType === "DII") {
            if (objResp.data.ResponseObject.type === "success") {
                data = objResp.data.ResponseObject.resultset.map((each) => (
                    {
                        id: 1, equity: {
                            equity_heading: 'Equity',
                            equity_gross_purchase: each.BuyValue,
                            equity_gross_sales: each.SellValue,
                            equity_net_investment: each.NetValue,
                            equity_cumulativie_net_investment: ''
                        }, debit: {
                            debt_heading: '',
                            debt_gross_purchase: '',
                            debt_gross_sales: '',
                            debt_net_investment: '',
                            debt_cumulativie_net_investment: ''
                        }, heading: {
                            date: each.TransactionDate,
                            gross_purchase: 'Buy Value',
                            gross_sales: 'Sell Value',
                            net_investment: 'Net Value',
                            cumulativie_net_investment: ''
                        }
                    }
                ));
            }
        } else if (sType === "MF") {
            if (objResp.data.ResponseObject.type === "success") {
                data = objResp.data.ResponseObject.resultset.map((each) => (
                    {
                        id: 1, equity: {
                            equity_heading: 'Equity',
                            equity_gross_purchase: each.EquityGrossPurchase,
                            equity_gross_sales: each.EquityGrossSale,
                            equity_net_investment: each.EquityNetPurchaseSales,
                            equity_cumulativie_net_investment: ''
                        }, debit: {
                            debt_heading: 'Debit',
                            debt_gross_purchase: each.DebtGrossPurchase,
                            debt_gross_sales: each.DebtGrossSales,
                            debt_net_investment: each.DebtNetPurchaseSales,
                            debt_cumulativie_net_investment: ''
                        }, heading: {
                            date: each.TransactionDate,
                            gross_purchase: 'Gross Purchase',
                            gross_sales: 'Gross Sales',
                            net_investment: 'Net Purchase Sales',
                            cumulativie_net_investment: ''
                        }
                    }
                ));
            }
        }


        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: data };

    } catch (error) {

        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };

    }
}

async function _bulkBlockDealData(sExchange, sDealType, sFromDate, sToDate, nPage, nPagesize, jtenantToken) {
    //Hari: modifying the sectorWiseNews data structure according to ag grid
    // sExchange- to get news for particular exchange 
    // sDealType- get news from particular deal
    // sFromDate-sToDate - to get bult block news between sFromDate and sToDate
    // nPage- number of pages of news
    // nPagesize- number of size in each page of news
    // jtenantToken- to get bulk and block news for particular tenant


    try {
        let objResp = await getBulkBlockDealData({ exchange: sExchange, dealType: sDealType, fromDate: sFromDate, toDate: sToDate, page: nPage, pagesize: nPagesize, jtenantToken: jtenantToken });
        if (objResp.data.ResponseObject.type === "success") {
            const arrBulkBlockData = objResp.data.ResponseObject.resultset.map((each) => ({ date: each.Date, Symbol: each.ScripName, type: each.BuySell === "B" ? "Buy" : "Sell", qty: each.QuantityShares, transfer: each.AveragePrice }));
            return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: arrBulkBlockData };
        } else {
            return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: null };
        }
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: error };
    }
}


async function _mergerDemergerData(sFromDate, sToDate, jtenantToken) {
    //Hari: modifying the sectorWiseNews data structure according to ag grid
    //sFromDate-sToDate - to get mergers and demergers data between sFrom and sTodate
    // jtenantToken- to get merger and demergers news for particular tenant

    try {
        let objResp = await getMergerDemergerData({ fromDate: sFromDate, toDate: sToDate, jtenantToken: jtenantToken });
        if (objResp.data.ResponseObject.type === "success") {
            const arrMergeRowData = objResp.data.ResponseObject.resultset.map((each) => ( // modifying datat according to ag grid
                { type: each.Flag, fromCompany: each.MergedFrom_CompanyName, toCompany: each.MergedInto_CompanyName, issueDate: each.XDate, recordDate: each.RecordDate, ratio: each.MergerRatio }
            ));
            return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: arrMergeRowData };
        } else {
            return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: null };
        }
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: error };
    }
}

async function _hotPursuitData(nItems, jtenantToken, holdingsScrips) {

    // nItems - to get number of hot pursuit data
    // jtenantToken-to get hot pursuit data for particular tenant
    // holdingsScrips - to find the scrips having holdings or not
    try {
        let objResp = await getHotPursuitData(nItems, jtenantToken);
        if (objResp.data.ResponseObject.type === "success" && objResp.data.ResponseObject.resultset.length) {
            const arrUniqueScrips = [];
            const seenCombination = {};
            objResp.data.ResponseObject.resultset.forEach(element => {
                const segmentAndToken = `${element?.ScripData_NSE !== "-" ? element.ScripData_NSE.MarketSegmentId : element.ScripData_BSE.MarketSegmentId}-${element.ScripData_NSE !== "-" ? element.ScripData_NSE.ODINCode : element.ScripData_BSE.ODINCode}`;
                if (!seenCombination[segmentAndToken]) {
                    seenCombination[segmentAndToken] = true;
                    if (element?.ScripData_NSE !== "-" || element?.ScripData_BSE !== "-") {
                        arrUniqueScrips.push({
                            "mkt": getApiExchangeNameFromMktSegId(element?.ScripData_NSE !== "-" ? element.ScripData_NSE.MarketSegmentId : element.ScripData_BSE.MarketSegmentId), "token": element.ScripData_NSE !== "-" ? element.ScripData_NSE.ODINCode : element.ScripData_BSE.ODINCode
                        });
                    } else {
                    }
                } else { }
            });
            const arrScripInfo = await _getScripsInfo(arrUniqueScrips)
            for (let eachNews of objResp.data.ResponseObject.resultset) {
                const holdings = holdingsScrips?.find((hotData) => hotData?.nMarketSegmentId?.toString() === (eachNews?.ScripData_NSE !== '-') ? eachNews?.ScripData_NSE?.MarketSegmentId?.toString() : eachNews?.ScripData_BSE?.MarketSegmentId?.toString() && hotData?.nToken?.toString() === eachNews?.ScripData_NSE !== '-' ? eachNews?.ScripData_NSE.ODINCode?.toString() : eachNews?.ScripData_BSE?.ODINCode?.toString());
                if (holdings) {
                    eachNews.isHoldings = true;
                } else {
                    eachNews.isHoldings = false;
                }
            }

            const arrUpdatedHotPursuitNews = [];
            for (let jsonHotNews of objResp.data.ResponseObject.resultset) {
                let nSegmentId = jsonHotNews.ScripData_NSE !== "-" ? jsonHotNews.ScripData_NSE.MarketSegmentId : jsonHotNews.ScripData_BSE !== "-" ? jsonHotNews.ScripData_BSE.MarketSegmentId : null
                let nToken = jsonHotNews.ScripData_NSE !== "-" ? jsonHotNews.ScripData_NSE.ODINCode : jsonHotNews.ScripData_BSE !== "-" ? jsonHotNews.ScripData_BSE.ODINCode : null
                const scriInfo = arrScripInfo?.data.objScripsResp?.result?.find((each) => each.id === nSegmentId?.toString() + "-" + nToken?.toString())
                const updatedHotPursuitNews = {
                    id: jsonHotNews.SNo,
                    news_content: jsonHotNews.Heading,
                    category_name: null,
                    date_time: _handleTimeDifference(jsonHotNews.Date, jsonHotNews.Time),
                    news_channel_name: null,
                    exchange_type: null,
                    sub_category: null,
                    category: [],
                    // hari K.11-12-2023:news- fixed data issues- start
                    odin_code: jsonHotNews?.ScripData_NSE !== "-" ? jsonHotNews.ScripData_NSE.ODINCode : jsonHotNews.ScripData_BSE !== "-" ? jsonHotNews.ScripData_BSE.ODINCode : null,
                    series: jsonHotNews.ScripData_NSE !== "-" ? jsonHotNews.ScripData_NSE.Series : jsonHotNews.ScripData_BSE !== "-" ? jsonHotNews.ScripData_BSE.Series : null,
                    symbol: jsonHotNews.ScripData_BSE.Symbol,
                    nSegmentId: jsonHotNews.ScripData_NSE !== "-" ? jsonHotNews.ScripData_NSE.MarketSegmentId : jsonHotNews.ScripData_BSE !== "-" ? jsonHotNews.ScripData_BSE.MarketSegmentId : null,
                    nToken: jsonHotNews.ScripData_NSE !== "-" ? jsonHotNews.ScripData_NSE.ODINCode : jsonHotNews.ScripData_BSE !== "-" ? jsonHotNews.ScripData_BSE.ODINCode : null,
                    // hari K.11-12-2023:news- fixed data issues- end
                    nLtp: 0,
                    nLtpChange: 0,
                    nLtpPercent: 0,
                    scripInfo: scriInfo
                };
                arrUpdatedHotPursuitNews.push(updatedHotPursuitNews);
            }
            const filterUpdatedHotPursuitNews = arrUpdatedHotPursuitNews?.filter((each) => each.odin_code !== (undefined || null));
            return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: filterUpdatedHotPursuitNews };
        } else {
            return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: null };
        }

    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: error };
    }
}

const _handleArrActiveNewsLtp = (arrTouchLineData, objActiveNewsData) => {
    // objActiveNewsData is a news scrips it contains the all details
    //arrTouchLineData is arra of details from live data
    if (arrTouchLineData?.length > 0) {
        if (arrTouchLineData[TL_INDEX.SEGMENT_ID] + '_' + arrTouchLineData[TL_INDEX.TOKEN] === getMktSegIdFromMappedMktSegId(objActiveNewsData?.nSegmentId) + "_" + objActiveNewsData?.nToken) {

            // let nAbsPrevColse = (arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]);
            // if (nAbsPrevColse > 0) {
            //     nAbsPrevColse = '+' + nAbsPrevColse.toString();
            // } else if (nAbsPrevColse < 0) {
            //     nAbsPrevColse = nAbsPrevColse.toString();
            // }

            return {
                nLtp: arrTouchLineData[TL_INDEX?.LAST_TRADE_PRICE],
                nLtpChange: arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE],
                nLtpPercent: arrTouchLineData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE],
                exchange: arrTouchLineData[TL_INDEX.EXCHANGE].split("_")[0]
            };
        } else { }
    } else { }
};


const _getTabs = (nCMOTMode, arrAnnouncement, arrNewsData, arrHotPursuitData) => {
    if (nCMOTMode === NEWS_CMOT_MODE.CMOT_LITE) {
        return [
            {
                id: 1,
                name: "News",
                tabKey: 'news',
                data: arrNewsData
            },
            {
                id: 2,
                name: "Announcements",
                tabKey: 'announcements',
                data: arrAnnouncement
            }
        ];
    } else if (nCMOTMode === NEWS_CMOT_MODE.CMOT_PRO) { // Hari K:  changes might need to be done for portfolio and side tray watchlist news
        return [
            {
                id: 1,
                name: "Hot Pursuit",
                tabKey: 'hot_pursuit',
                data: arrHotPursuitData
            },
            {
                id: 2,
                name: "News",
                tabKey: 'news',
                data: arrNewsData
            },
            {
                id: 3,
                name: "Announcements",
                tabKey: 'announcements',
                data: arrAnnouncement
            }
        ];
    }
};

/*Shuaib P BT-117131 Breeze Portfolio - Holdings - News Start */

function _sortHoldingNewsCards(objSingleNews, arrPrevNews) {

    /*In this function we are sorting cards with respect to current time and date so that card which holds the latest news will be in the start */

    try {

        let modifiedDate = objSingleNews?.Date.split(" ")[0];
        let strTime = objSingleNews?.Time;
        let arrSortedNews = [...arrPrevNews];
        let targetDate;
        if (strTime) {
            targetDate = dayjs(`${modifiedDate} ${strTime}`, { format: 'DD/MM/YYYY HH:mm' });
        } else {
            targetDate = dayjs(`${modifiedDate} 23:59:59`, { format: 'DD/MM/YYYY HH:mm:ss' });
        }
        let currentDate = dayjs();
        const secondsDifference = Math.abs(targetDate.diff(currentDate, 'second'));

        objSingleNews['Latest'] = secondsDifference;

        arrSortedNews.push(objSingleNews);

        arrSortedNews.sort((a, b) => {
            return a?.Latest - b?.Latest;
        });

        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: arrSortedNews };
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}

/*Shuaib P BT-117131 Breeze Portfolio - Holdings - News End */

export { _sortHoldingNewsCards, _getTabs, _mergerDemergerData, _handleTimeDifference, _handleArrActiveNewsLtp, _hotPursuitData, _bulkBlockDealData, _FIIDIIMFData, _sectorWiseNewsSuccess, _exchangeAnnouncementsSuccess, _announcementsExchange };